<template>
    <div class="box">
        <div :class="isMobile ? 'mobile noresult' : 'pc noresult'">
            <a-icon type="clock-circle" class="icon text-color"/>
            <p class="text text-color">正在投保中...</p>
            <div class="policy_no">
                <p>保单正在投保中，稍后请至</p>
                 <p class="text-color" @click="handleCopy">
                    <em style="word-break: break-all;">{{ this.queryUrl }}</em>
                    <em>（点击可复制）</em>
                </p>
                <p>中的<span class="text-color">【保单管理】</span>查看投保进度，若投保成功会显示在已承保保单中</p>
            </div>
            <a href="#" ref="noresult"></a>
        </div>
    </div>
</template>
<script>
import queryUrlObj from './queryUrl'
export default {
    data() {
        return {
            isMobile: false, // 判断设备
            policyId: '',
						queryUrl: 'https://www.ssish.com', // 保单查询地址
						productCode: '' // 产品code
        };
    },
    created() {
        const { policyId, productCode } = this.$route.query;
        this.policyId = policyId;
        this.productCode = productCode;
        this.savePageSuc();
        this.isMobile = this.isMobileFunc();

				// 如果有地址
				if(queryUrlObj[productCode]) {
					this.queryUrl = queryUrlObj[productCode];
				}
    },
    mounted() {
        const { policyId } = this.$route.query;
        this.policyId = policyId;
        this.$nextTick(() => {
            /* eslint-disable */
            window.clairvoyanceRecord.save();
            this.$refs.noresult.click();
            window.clairvoyanceRecord.finish({
                notStopRecord: true,
                policyId: this.$route.query.policyId
            });
        });
  },
  methods: {
    //判断设备是PC端还是移动端: false PC端 | true 移动端
    isMobileFunc (){
      return !!navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|WebOS|Windows Phone|Phone)/i);
    },
    handleCopy() {
      import('clipboard-copy').then(copy => {
        //复制当前地址
        copy.default(this.queryUrl).then(() => {
          this.$message.success('链接已复制成功！');
        });
      });
    },
    savePageSuc() {
      this.$api
        .savePageSuc({
          closeType: 'result-page',
          policyId: this.policyId,
          msgId: sessionStorage.getItem('clairvoyance_message_id')
        })
        .then(res => {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="less" scoped>
    .box {
        width: 100%;
        min-height: 100vh;
        background: #f9f9f9;
        .noresult {
            width: 100%;
            text-align: center;
            padding-top: 39px;
            .icon {
                font-size: 120px;
            }
            .text {
                margin-top: 16px;
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #1B7CF8;
            }
            .policy_no {
                width: 316px;
                text-align: center;
                background: #FFFFFF;
                padding: 28px 0;
                box-sizing: border-box;
                line-height: 24px;
                box-shadow: 0px 4px 23px 4px rgba(182, 216, 234, 0.2);
                border-radius: 20px;
                margin: 24px auto;
                font-size: 17px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #343141;
                em {
                    font-style: italic;
                }
            }
           
            
        }
        .mobile {
            .text-color {
                color: #1B7CF8;
            }
            
        
        }
        .pc {
            .text-color {
                color: #fe8f2d;
            }
        }
    }
</style>
